<app-bulk-operations [actionCallback]="bulkActionCallback"></app-bulk-operations>
<app-card-detail-layout header="On Deck" 
    [isLoading]="isLoading"
    [items]="series"
    [filters]="filters"
    [pagination]="pagination"
    (pageChange)="onPageChange($event)"
    (applyFilter)="updateFilter($event)"

    >
    <ng-template #cardItem let-item let-position="idx">
        <app-series-card [data]="item" [libraryId]="item.libraryId" (reload)="loadPage()" (selection)="bulkSelectionService.handleCardSelection('series', position, series.length, $event)" [selected]="bulkSelectionService.isCardSelected('series', position)" [allowSelection]="true"></app-series-card>
    </ng-template>
</app-card-detail-layout>
